/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const visitClinicalConversations = sqliteTable('visit_clinical_conversations', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  clinic_id: text('clinic_id'),
  patient_id: text('patient_id'),
  visit_id: text('visit_id'),
  appointment_id: text('appointment_id'),
  section_key: text('section_key'),
  title: text('title'),
  status: text('status'),
  started_at: text('started_at'),
  completed_at: text('completed_at'),
  summary_appended_at: text('summary_appended_at'),
  created_by: text('created_by'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
  deleted_at: text('deleted_at'),
});
